import { render, staticRenderFns } from "./PurchasePaymentMerge.vue?vue&type=template&id=af8d2cd8"
import script from "./PurchasePaymentMerge.vue?vue&type=script&lang=js"
export * from "./PurchasePaymentMerge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports